import PartnerTemplate from '../components/marketing/PartnerTemplate';

/* Stephens × Clarid — channel partner (dual lockup). CRA analytics + qualified investment. */
export default function StephensPartnerPage() {
  return (
    <PartnerTemplate
      docTitle="Stephens + Clarid — CRA Intelligence Meets Qualified Investment"
      lockup="dual"
      partnerName="Stephens"
      partnerLogo="/stephens-logo.svg"
      eyebrow="§ PARTNERSHIP · STEPHENS × CLARID"
      headline={<>CRA intelligence meets <span className="frame-quote">qualified investment.</span></>}
      lead="Clarid identifies exactly where a bank's CRA performance falls short — by assessment area, product, census tract, and income level. Stephens has the bond inventory, public-finance products, and structured solutions that fill those gaps. Together — precision analytics connected to investment products that actually move the bank's CRA needle."
      thesisKicker="§ 01 · WHY THIS PARTNERSHIP"
      thesisHeadline="Precision CRA analytics, connected to the investments that close the gap."
      thesis={[
        {
          well: '01',
          title: 'Clarid finds the exact gap',
          body: 'Clarid pinpoints where CRA performance falls short — by assessment area, product, census tract, and income level — so the conversation starts from data, not guesswork.',
        },
        {
          well: '02',
          title: 'Stephens fills it with qualified inventory',
          body: "Bond inventory, public-finance products, and structured solutions matched to the bank's delineated footprint — qualified dollars where the bank is actually exposed, not generic eligibility.",
        },
        {
          well: '03',
          title: 'A CRA strategy from gap to close',
          body: 'Analytics and inventory in one workflow: the bank gets a data-driven CRA plan, and analysts stop hand-geocoding properties for every pitch.',
        },
      ]}
      bringsHeadline="CRA depth, built for fixed-income analysts."
      depth={[
        { label: 'CRA', txt: 'Lending distribution across LMI, minority, and rural tracts; assessment-area demographics; size-adaptive exam-readiness scoring.' },
        { label: 'Bond Analysis', txt: "Takes any mix of CUSIPs, maps every underlying property to a bank's delineated assessment areas, computes CRA-qualified dollar totals, and generates a client-ready pitch PDF." },
        { label: 'Fair lending', txt: 'Denial-rate and pricing-disparity analysis reproducing the FRB Fair Lending Tool to the decimal.' },
      ]}
      proofs={[
        { stat: 'Bond Analysis Module', desc: 'Maps CUSIPs to assessment areas and computes CRA-qualified dollars — a client-ready pitch PDF in one workflow.' },
        { stat: 'FRB Fair Lending Tool — to the decimal', desc: "Clarid reproduces the Federal Reserve's fair-lending methodology exactly, not an approximation." },
        { stat: 'Deterministic · multi-provider', desc: "Circuit-breaker fallback across providers — it kept running through Anthropic's largest-ever outage. SHA-256-verified exam packages." },
      ]}
      integration={{
        kicker: '§ 03 · HOW IT WORKS TOGETHER',
        headline: 'From CRA gap to qualified close.',
        lead: 'Clarid quantifies the CRA gap by assessment area; Stephens sources qualified investments against it; the bank closes with a data-backed pitch.',
        barLabel: 'clarid.analytics → stephens.inventory → cra.close',
        flow: [
          { name: 'Clarid · CRA gap analysis', sub: 'Assessment area · tract · income gaps', clarid: true },
          { name: 'Stephens · qualified inventory', sub: 'Bonds · public finance · structured solutions' },
          { name: 'CRA needle moves', sub: 'Qualified dollars · examiner-ready' },
        ],
        tags: [
          { label: '✓ Bond Analysis Module · shipped', kind: 'shipped' },
          { label: '✓ CRA gap analysis · shipped', kind: 'shipped' },
          { label: '◇ Joint pitch workflow · roadmap', kind: 'roadmap' },
        ],
        note: '▢ integration shape — illustrative; final mechanics scoped with Stephens. Roadmap items marked as roadmap.',
      }}
      contact={{ name: 'Bobby Sloan', title: 'Founder & CEO, Clarid', email: 'bobby@clarid.ai' }}
    />
  );
}
